import "./style.scss";
import { createPortal } from "react-dom";
import { useEffect } from "react";

const ModalPortal = ({ children }: { children: React.ReactNode }) => {
  const modalRoot = document.getElementById("modal-root");

  useEffect(() => {
    if (!modalRoot) return;

    const isOpen = Boolean(children);

    if (isOpen) {
      modalRoot.classList.add("active");
      document.body.classList.add("hidden");
    } else {
      modalRoot.classList.remove("active");
      document.body.classList.remove("hidden");
    }

    return () => {
      modalRoot.classList.remove("active");
      document.body.classList.remove("hidden");
    };
  }, [children, modalRoot]);

  if (!modalRoot) return null;

  return createPortal(children, modalRoot);
};

export default ModalPortal;
